import { useEffect } from 'react';
import confetti from 'canvas-confetti';

const BRAND_COLORS = ['#0E9F6E', '#0055FF', '#FDCC6D', '#C9963F', '#FFFFFF'];

export function ConfettiCelebration() {
  useEffect(() => {
    const durationMs = 3500;
    const endTime = Date.now() + durationMs;
    let animationFrameId = 0;

    confetti({
      particleCount: 120,
      spread: 80,
      startVelocity: 42,
      origin: { y: 0.55 },
      colors: BRAND_COLORS,
      disableForReducedMotion: true,
    });

    const shootSideConfetti = () => {
      confetti({
        particleCount: 4,
        angle: 60,
        spread: 62,
        origin: { x: 0, y: 0.65 },
        colors: BRAND_COLORS,
        disableForReducedMotion: true,
      });
      confetti({
        particleCount: 4,
        angle: 120,
        spread: 62,
        origin: { x: 1, y: 0.65 },
        colors: BRAND_COLORS,
        disableForReducedMotion: true,
      });

      if (Date.now() < endTime) {
        animationFrameId = window.requestAnimationFrame(shootSideConfetti);
      }
    };

    animationFrameId = window.requestAnimationFrame(shootSideConfetti);

    return () => {
      window.cancelAnimationFrame(animationFrameId);
      confetti.reset();
    };
  }, []);

  return null;
}
